module.exports = __webpack_public_path__ + "static/media/app-logo.2c2eacd7.png";